import { createSelector } from '@lumapps/redux/reselect';
import { accountTypeSelector } from '@lumapps/user/ducks/selectors';
import { UserAccountType } from '@lumapps/user/types';

import { CommunityCreationDialogSteps } from '../types';

export const creationDialogAvailableStepsSelector = (isSpace = false) =>
    createSelector(accountTypeSelector, (accountType) =>
        Object.keys(CommunityCreationDialogSteps).filter((step) => {
            switch (step) {
                case CommunityCreationDialogSteps.templates:
                    // don't show this step if we are creating a space
                    return !isSpace;
                case CommunityCreationDialogSteps.microsoftGroups:
                    // show this step only if user is of type MS & creating a community
                    return accountType === UserAccountType.MICROSOFT && !isSpace;
                default:
                    // show step by default
                    return true;
            }
        }),
    );
